export  const CourseCount = (props) => {
    const { pClass, spanClass, course } = props;
    return (
        <p className={pClass}>該当コース<span className={spanClass}> {course} </span>件</p>
    );
};